import { useHomePage } from "./logic";
import { HomePageTemplate } from "./template";

export const HomePage = (): JSX.Element => {
  const logic = useHomePage();
  return <HomePageTemplate {...logic} />;
};
